import React from "react";
import { ScanReportType } from "@sscs/types";
import { CopyIcon, IconButton, Toast } from "@sscs/ui";
import { buildRlPurl } from "@sscs/utils";
import { PortalPurlLink } from "Components";
import { PurlComponents } from "../../../types";
import UploadedByInfo from "../../UploadedByInfo/UploadedByInfo";
import styles from "./sharingStatusText.module.scss";

type SharingStatusTextProps = {
  projectId: string;
  packageId: string;
  purlComponents: PurlComponents;
  reportType: ScanReportType;
  timesShared: number;
  user: {
    first_name: string;
    last_name: string;
    email: string;
  } | null;
  importedFrom: string | null;
};

const SharingStatusText = ({
  projectId,
  packageId,
  purlComponents,
  reportType,
  timesShared,
  user,
  importedFrom,
}: SharingStatusTextProps): React.JSX.Element => {
  return (
    <div>
      <div className={styles["status-text"]}>
        Report for{" "}
        <PortalPurlLink
          projectId={projectId}
          packageId={packageId}
          projectName={purlComponents.projectName}
          packageName={purlComponents.packageName}
          version={purlComponents.version}
        />
        {timesShared === 0 ? (
          <>has not been shared</>
        ) : (
          <>
            has been shared <strong>{timesShared.toLocaleString()}</strong> time
            {timesShared > 1 ? "s" : ""}
          </>
        )}
        <span className={styles.divider}>&nbsp;|</span>
        <IconButton
          tooltipTitle="Copy full PURL"
          size="small"
          className={styles["copy-purl"]}
          onClick={async () => {
            await navigator.clipboard.writeText(
              buildRlPurl(
                purlComponents.projectName,
                purlComponents.packageName,
                purlComponents.version,
                reportType,
              ),
            );
            Toast.show({
              title: "PURL copied successfully!",
              type: "success",
            });
          }}
        >
          <CopyIcon />
        </IconButton>
      </div>
      <div>
        <UploadedByInfo user={user} importedFrom={importedFrom} />
      </div>
    </div>
  );
};

export default SharingStatusText;
